var React = require('react');

function RecycleIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-0.704 -0.5)"},[React.createElement("path",{"d":"M18.138,1.77a2.433,2.433,0,0,0-4.275,0L10.656,7.486l1.425.847,3.206-5.716a.811.811,0,0,1,1.423,0l5.675,10.448-1.1.7,4.4,3.179-.761-5.481-1.139.72L18.143,1.78Z","fill":"#383a36","key":0}),React.createElement("path",{"d":"M2.459,25.489l5.71-9.635,1.1.66.634-5.5L5.577,14.3l1.17.7-5.7,9.615-.01.018a2.541,2.541,0,0,0,2.137,3.811H9.588V26.752H3.175A.847.847,0,0,1,2.459,25.489Z","fill":"#383a36","key":1}),React.createElement("path",{"d":"M26.331,19.766l3.206,5.716a.847.847,0,0,1-.712,1.27H17.646V25.4l-4.936,2.2,4.936,2.2V28.446H28.825a2.541,2.541,0,0,0,2.137-3.811l-3.206-5.716Z","fill":"#383a36","key":2})]));
}

RecycleIcon.defaultProps = {"width":"30.593","height":"29.299","viewBox":"0 0 30.593 29.299"};

module.exports = RecycleIcon;

RecycleIcon.default = RecycleIcon;
